import { render, staticRenderFns } from "./ViewDockingStation.vue?vue&type=template&id=4d9bdc5e&scoped=true&lang=pug&"
import script from "./ViewDockingStation.vue?vue&type=script&lang=js&"
export * from "./ViewDockingStation.vue?vue&type=script&lang=js&"
import style0 from "./ViewDockingStation.vue?vue&type=style&index=0&id=4d9bdc5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9bdc5e",
  null
  
)

export default component.exports